import type * as React from "react";
import { memo } from "react";
import PageTitle from "~/common/components/PageTitle/v1/PageTitle";
import UserAccountsTable from "~/features/userAdministration/manageUsers/components/UserAccountsTable";
import UserAccountsPlug from "~/features/userAdministration/manageUsers/components/UserAccountsPlug";
import { IconType } from "~/common/components/icon/IconType";
import { useTranslation } from "react-i18next";
import { Button } from "~/common/mui";
import { DefaultButtonIcon } from "~/common/components/icon/Icon";

export interface UserAccountsComponentProps {
  results: UserAccountEntry[];
  totalAmount: number;
  manageUserLink: string;
  unit: {
    name: string;
    displayUid: string;
  };
}

export interface UserAccountEntry {
  firstName: string;
  lastName: string;
  status: boolean;
  uid: string;
  roles: string[];
}

const UserAccountsTablePage: React.FC<UserAccountsComponentProps> = (props) => {
  const { t } = useTranslation();

  return (
    <>
      <PageTitle title={t("text.company.manageusers.label")} />
      <div className="scha__user-accounts__unit">
        <h3 className="scha__user-accounts__unit__name">
          {`${props.unit.name} (${props.unit.displayUid})`}
          {` | `}
          {t("text.company.manageusers.user.count", {
            count: props.results.length,
          })}
        </h3>
        <Button
          href={props.manageUserLink}
          data-test-id="create-user-0"
          startIcon={<DefaultButtonIcon type={IconType.Plus} />}
        >
          {t("userList.createNewUser")}
        </Button>
      </div>
      <UserAccountsTable {...props} />
      <div className="mt-30 mb-2 d-flex flex-justify-end">
        <Button
          href={props.manageUserLink}
          data-test-id="create-user-1"
          startIcon={<DefaultButtonIcon type={IconType.Plus} />}
        >
          {t("userList.createNewUser")}
        </Button>
      </div>
    </>
  );
};

const UserAccountsPage: React.FC<UserAccountsComponentProps> = (props) => (
  <div className="scha__user-accounts">
    {props.results.length !== 0 ? (
      <UserAccountsTablePage {...props} />
    ) : (
      <UserAccountsPlug manageUserLink={props.manageUserLink} />
    )}
  </div>
);

export default memo(UserAccountsPage);

export interface UserAccountsJSPProps {
  results: UserAccountEntry[];
  totalAmount: number;
  manageUserLink: string;
}

export function createManageUsersPage(json: string) {
  const data: UserAccountsJSPProps = JSON.parse(json);

  return <UserAccountsPage {...data} unit={window.SCHA.user.selectedAccount ?? EMPTY_UNIT} />;
}

const EMPTY_UNIT = { displayUid: "NA", name: "N/A" };
